import angular from 'angular';
import bouncingTooltip from './bouncingTooltip';
import './style.scss';

export default angular
  .module('components.bouncingTooltip', [])
  .component('bouncingTooltip', bouncingTooltip).name;
